/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  CompanyEmployeeRoleDto,
  CompanyEmployeeRoleDtoFromJSON,
  CompanyEmployeeRoleDtoFromJSONTyped,
  CompanyEmployeeRoleDtoToJSON,
} from "./CompanyEmployeeRoleDto";

/**
 *
 * @export
 * @interface CompanyEmployeeInviteDto
 */
export interface CompanyEmployeeInviteDto {
  /**
   *
   * @type {string}
   * @memberof CompanyEmployeeInviteDto
   */
  id: string;
  /**
   *
   * @type {string}
   * @memberof CompanyEmployeeInviteDto
   */
  email: string;
  /**
   *
   * @type {CompanyEmployeeRoleDto}
   * @memberof CompanyEmployeeInviteDto
   */
  companyEmployeeRole: CompanyEmployeeRoleDto;
}

export function CompanyEmployeeInviteDtoFromJSON(json: any): CompanyEmployeeInviteDto {
  return CompanyEmployeeInviteDtoFromJSONTyped(json, false);
}

export function CompanyEmployeeInviteDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CompanyEmployeeInviteDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    email: json["email"],
    companyEmployeeRole: CompanyEmployeeRoleDtoFromJSON(json["companyEmployeeRole"]),
  };
}

export function CompanyEmployeeInviteDtoToJSON(value?: CompanyEmployeeInviteDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    email: value.email,
    companyEmployeeRole: CompanyEmployeeRoleDtoToJSON(value.companyEmployeeRole),
  };
}
